import Vue from 'vue';

export const loginService = {
  doLogin(username, password) {
    return Vue.axios.post('/session', {
      username,
      password
    });
  },
  doMagicLogin(username, passcode) {
    return Vue.axios.post('/session/magic', {
      username,
      passcode
    });
  },
  async getMagicCode(username) {
    return Vue.axios
      .get('/session/code', {
        params: {
          user: username
        }
      })
      .then(res => res.data);
  }
};
